import { useState, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import "./mainCourse.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import DataState from "src/components/common/DataState";
import useApiList from "src/hooks/useApiList";
import { foodImageSource } from "src/config/foodImage";
import HeaderSection from "../menu_first_section/HeaderSection";
import { setSelectedCategory } from "../../../../redux/slices/menuSlice";

const itemImageFallback = "/uploads/item_image/82accee4-e475-4af5-9fe8-728b4ec06e9a.jpg";

export default function WeServeMainCourses() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedMainCourse, setSelectedMainCourse] = useState(null);
  const courses = useApiList("/mainCourses/");
  const mainCourses = courses.data;
  const selectedCourse = mainCourses.find(
    (course) => course.main_course_name === selectedMainCourse
  );
  const courseItems = useApiList(
    selectedCourse ? `/mainCourses/${selectedCourse.id}/items` : null
  );
  const items = courseItems.data;

  /* ---------------- unique item names ---------------- */
  const itemNames = useMemo(() => {
    return [...new Set(items.map((i) => i.item_name))];
  }, [items]);

  /* ---------------- item click handler (NAVIGATE TO MENU) ---------------- */
  const handleItemClick = (itemName) => {
    dispatch(setSelectedCategory(itemName));
    navigate("/menu");
  };

  return (
    <Box className="main-course-section" sx={{ p: 0 }}>
      {/* MAIN COURSES */}
      <HeaderSection
        header="We Serve"
        categories={mainCourses.map((course) => ({
          name: course.main_course_name,
          image: foodImageSource(
            course.item_image || course.image || itemImageFallback,
            course.mimeType
          ),
        }))}
        selectedCategory={selectedMainCourse}
        setSelectedCategory={setSelectedMainCourse}
        type="main" // main courses
      />

      <ListStatus request={courses} label="menu categories" />
      {selectedCourse && <ListStatus request={courseItems} label="dishes" />}

      {itemNames.length > 0 && (
        <Box className="main-course-items">
        <Typography component="h3" className="main-course-items-title">Explore {selectedMainCourse}</Typography>
        <HeaderSection
          header=""
          categories={itemNames}
          selectedCategory={null}
          setSelectedCategory={handleItemClick}
          type="items" // items under main
        />
        </Box>
      )}
    </Box>
  );
}

function ListStatus({ request, label }) {
  if (request.status === "loading" || request.status === "error" || (request.status === "success" && request.data.length === 0)) {
    return <DataState loading={request.status === "loading"}
      title={request.status === "error" ? "Menu temporarily unavailable" : `Our ${label} are coming soon`}
      message={request.status === "error" ? "Please try again to explore our freshly prepared dishes." : "Check back shortly for more from our kitchen."}
      onRetry={request.status === "error" ? request.retry : undefined} />;
  }
  return null;
}
